import type { AssetListItem } from '~/data/AssetListItem/AssetListItem';
import type { AppState } from '~/reducers';
import inventoryV2ListApi from '~/domain/inventory-v2/api/inventory-v2-list-api';

const pageEndpoint = inventoryV2ListApi.endpoints.getInventoryV2Page;

const findInPagedList = (state: AppState, iprId: string): AssetListItem | undefined => {
  const cachedArgs = inventoryV2ListApi.util.selectCachedArgsForQuery(state, 'getInventoryV2Page');
  for (const args of cachedArgs) {
    const asset = pageEndpoint
      .select(args)(state)
      .data?.machines.find((item) => item.assetDetails.id === iprId);
    if (asset) {
      return asset;
    }
  }
  return undefined;
};

/**
 * Finds one asset among the rows the inventory list has loaded, from either the whole-fleet
 * list or the cached pages of the paged list.
 */
export const selectListedAssetById = (state: AppState, iprId: string): AssetListItem | undefined =>
  state.assetList.assets.find((item) => item.assetDetails.id === iprId) ??
  findInPagedList(state, iprId);

/**
 * Finds one asset by id: the asset open in details first, then the loaded list rows.
 */
export const selectAssetById = (state: AppState, iprId: string): AssetListItem | undefined => {
  const detailsAsset = state.assetMapAndDetails.asset;
  if (detailsAsset?.assetDetails?.id === iprId) {
    return detailsAsset;
  }
  return selectListedAssetById(state, iprId);
};
